import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { guaranteeChecks } from "../data/content";
export function Guarantee() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-144" data-mp="223y4543nw1ij">
      <div className="mx-auto max-w-3xl text-center" data-id="element-145" data-mp="221bvt28y5hz9">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-white" data-id="element-146" data-mp="1x5d5va7yzrwq">
          <ShieldCheckIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-147" data-mp="19co9d3cgomk4" />
          <span className="font-display text-3xl font-black leading-none" data-id="element-148" data-mp="14h8y8j5u94re">7</span>
          <span className="text-[10px] font-extrabold uppercase tracking-wider" data-id="element-149" data-mp="1j5lsnbpa2fjs">Day Guarantee</span>
        </div>
        <p className="mt-6 text-sm font-extrabold uppercase tracking-wider text-brand" data-id="element-150" data-mp="1ec97xcnpyswb">Your 7-Day Money-Back Guarantee</p>
        <h2 className="mt-3 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-navy sm:text-5xl" data-id="element-151" data-mp="qm6gmyrmpqyr">
          Try the BCM Diagnostic Blueprint™ Without Risk
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-152" data-mp="oz9kqu71izie">
          I want you to have the opportunity to review the system and decide whether it fits the way you work. After
          purchasing, you'll be able to:
        </p>
      </div>
      <ul className="mx-auto mt-8 grid max-w-2xl gap-3 sm:grid-cols-2" data-id="element-153" data-mp="12r6a4qhbqvb3">
        {guaranteeChecks.map(c => <li key={c} className="flex gap-3 rounded-xl bg-canvas p-4 text-base font-medium leading-snug text-navy" data-id="element-154" data-mp="61yxy92lhyju">
            <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-155" data-mp="b0a4oaxlfsxu" />
            {c}
          </li>)}
      </ul>
      <p className="mx-auto mt-8 max-w-2xl text-center text-lg leading-relaxed text-muted" data-id="element-156" data-mp="k0f0dntfd2w6">
        If, within seven days of purchase, you decide the Blueprint isn't right for you, contact us to request a refund
        under the applicable guarantee terms.
      </p>
      <div className="mt-10" data-id="element-157" data-mp="1vdr2nu9jddg8">
        <CtaButton note="Backed by a 7-Day Money-Back Guarantee." data-id="element-158" data-mp="3rigkqofuasiu">Get the BCM Blueprint — Risk-Free</CtaButton>
      </div>
    </section>;
}